import React, { useEffect, useState } from "react";
import { RefreshSavedCollections } from "@/components/CollectionsPage/redux/actions";
import CollectionsSelector from "@/components/CollectionsPage/redux/selectors/collectionsSelector";
import { BookmarkCollectionItemApi } from "@/components/common/api";
import { setIsOpenOnboardingSteps } from "@/components/ProfileSideDrawer/redux/slice";
import { getPlainTexts } from "@/helpers";
import { NON_ONBOARDED_STATUS, ONBOARDING_STATUS } from "@/helpers/constants";
import { buttonClickedEvent } from "@/helpers/TSDEvents";
import { useAppDispatch, useAppSelector } from "@/redux/hooks";
import { SignedinState } from "@/redux/slice/auth/enums/SignedInState";
import AuthTokenSelector from "@/redux/slice/auth/selectors/authToken";
import signedInStateSelector from "@/redux/slice/auth/selectors/signedInState";
import UserOnboardedSelector from "@/redux/slice/auth/selectors/userOnboarded";
import SegmentInfoSelector from "@/redux/slice/auth/selectors/userSegmentInfo";
import { handleOpenLoginModal } from "@/redux/slice/auth/slice";
import styles from "./BookmarkAction.module.scss";

interface BookmarkActionProps {
  type: string;
  itemId: number;
  isFromListingPage?: boolean;
  section?: string;
}

const Bookmark: React.FC<BookmarkActionProps> = (props) => {
  const { type: ItemType, itemId, isFromListingPage, section } = props;
  const dispatch = useAppDispatch();
  const authToken = useAppSelector(AuthTokenSelector);
  const signedInStatus = useAppSelector(signedInStateSelector);
  const isOnboarded = useAppSelector(UserOnboardedSelector);
  const SegmentInfoObject = useAppSelector(SegmentInfoSelector);
  const collectionsData = useAppSelector(CollectionsSelector);
  const [isItemBookmarked, setIsItemBookmarked] = useState<boolean>(false);

  const checkIsBookmarked = () => {
    if (collectionsData) {
      const allSaved = collectionsData?.all;
      const isExist = allSaved?.data?.some((item: any) => {
        return item?.id === itemId && item?.type === ItemType;
      });
      setIsItemBookmarked(isExist);
    }
  };

  const handleBookmarkClickApi = async () => {
    try {
      const bookmarkResponse: any = await BookmarkCollectionItemApi({
        authToken: authToken,
        type: ItemType,
        action: isItemBookmarked ? "remove" : "add",
        itemId,
      });

      if (bookmarkResponse?.savedContent) {
        await dispatch(RefreshSavedCollections(authToken));
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleOnClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();

    // Tracking Clevertap event
    buttonClickedEvent({
      button_name: "Bookmark",
      screen_name: getPlainTexts(section || ""),
      momverse_stage: isOnboarded ? ONBOARDING_STATUS[SegmentInfoObject?.type] : NON_ONBOARDED_STATUS,
      is_loggedin: signedInStatus === SignedinState.SIGNEDIN ? true : false,
    });

    if (isOnboarded && signedInStatus === SignedinState.SIGNEDIN) {
      handleBookmarkClickApi();
    } else {
      if (signedInStatus !== SignedinState.SIGNEDIN) {
        dispatch(handleOpenLoginModal(true));
      } else {
        if (signedInStatus === SignedinState.SIGNEDIN && !isOnboarded) {
          dispatch(setIsOpenOnboardingSteps(true));
        }
      }
    }
  };

  useEffect(() => {
    checkIsBookmarked();
  }, [collectionsData]);

  return (
    <div className={`${isFromListingPage ? styles.listingPageContainer : styles.container}`} onClick={handleOnClick}>
      {isFromListingPage ? (
        <span className={`icon-bookmark-fill ${isItemBookmarked ? styles.active : styles.noActive}`}></span>
      ) : (
        <span className={`icon-bookmark-fill ${styles.icon} ${isItemBookmarked ? "" : styles.noActive}`} />
      )}
    </div>
  );
};

export default Bookmark;
